import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResponse } from './page-response';

const API_URL = '/cargo/api/freight-forwarder-bids';

export interface FreightForwarderServiceDto {
  id: number;
  nameRu: string;
  nameEn: string;
}

export interface CreateFreightForwarderBidRequest {
  cargoRequestId: number;
  price: number;
  currencyId: number;
  deliveryDays: number;
  serviceIds: number[];
  note?: string;
}

export interface FreightForwarderBidDto {
  id: number;
  cargoRequestId: number;
  freightForwarderId: number;
  freightForwarderCompanyName: string;
  price: number;
  currencyId: number;
  currencyCode: string;
  /** Курс к KZT на сегодня */
  exchangeRate?: number;
  /** Цена в тенге для сравнения разных валют */
  priceKzt?: number;
  deliveryDays: number;
  note?: string;
  services: FreightForwarderServiceDto[];
  createdAt?: string;
  updatedAt?: string;
  isAccepted?: boolean;
  bidStatus?: 'PENDING' | 'ACCEPTED' | 'LOST';
  /** 1 = самая выгодная после конвертации в KZT */
  pricePosition?: number;
  bestPrice?: boolean;
}

export interface FreightForwarderBidFilterRequest {
  cargoRequestId?: number;
  isAccepted?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FreightForwarderBidService {
  constructor(
    private http: HttpClient
  ) {}

  createBid(request: CreateFreightForwarderBidRequest): Observable<FreightForwarderBidDto> {
    return this.http.post<FreightForwarderBidDto>(API_URL, request);
  }

  getAllBids(): Observable<FreightForwarderBidDto[]> {
    return this.http.get<FreightForwarderBidDto[]>(API_URL);
  }

  getAllBidsPaginated(page: number = 0, size: number = 20, filter?: FreightForwarderBidFilterRequest): Observable<PageResponse<FreightForwarderBidDto>> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('page', page.toString());
    httpParams = httpParams.set('size', size.toString());
    httpParams = httpParams.set('sort', 'id,desc');
    
    // Если есть фильтр, используем POST /search, иначе GET
    if (filter) {
      return this.http.post<PageResponse<FreightForwarderBidDto>>(`${API_URL}/search`, filter, { params: httpParams });
    } else {
      return this.http.get<PageResponse<FreightForwarderBidDto>>(API_URL, { params: httpParams });
    }
  }

  getBid(id: number): Observable<FreightForwarderBidDto> {
    return this.http.get<FreightForwarderBidDto>(`${API_URL}/${id}`);
  }

  getBidsByCargoRequestId(cargoRequestId: number): Observable<FreightForwarderBidDto[]> {
    return this.http.get<FreightForwarderBidDto[]>(`${API_URL}/cargo-request/${cargoRequestId}`);
  }

  updateBid(id: number, request: CreateFreightForwarderBidRequest): Observable<FreightForwarderBidDto> {
    return this.http.put<FreightForwarderBidDto>(`${API_URL}/${id}`, request);
  }

  deleteBid(id: number): Observable<void> {
    return this.http.delete<void>(`${API_URL}/${id}`);
  }
}
